export const theme = {
  colors: {
    primary: '#ff6900',
    secondary: '#1A1A1A',
    white: '#FFFFFF',
    lightGray: '#F4F4F4',
    text: '#333333'
  },
  transitions: {
    spring: { type: "spring", stiffness: 100, damping: 20 }
  },
  fonts: {
    main: "'Inter', sans-serif",
  },
  typography: {
    h1: { fontSize: "3.5rem", fontWeight: "800", letterSpacing: "-0.04em" },
    h2: { fontSize: "2.25rem", fontWeight: "700", letterSpacing: "-0.02em" },
    body: { fontSize: "1rem", fontWeight: "400", lineHeight: "1.6" }
  }
};